import React from 'react';
import { Book, Film, SlidersHorizontal, X } from 'lucide-react';
import { getAgeRatingOptions } from '../lib/christian-tips';

interface ChristianTipFilterProps {
  selectedType: string | null;
  setSelectedType: (type: string | null) => void;
  selectedAgeRating: string | null;
  setSelectedAgeRating: (rating: string | null) => void;
  sortBy: 'recent' | 'title';
  setSortBy: (sort: 'recent' | 'title') => void;
  resetFilters: () => void;
}

export default function ChristianTipFilter({
  selectedType,
  setSelectedType,
  selectedAgeRating,
  setSelectedAgeRating,
  sortBy,
  setSortBy,
  resetFilters
}: ChristianTipFilterProps) {
  const ageRatingOptions = getAgeRatingOptions();
  const hasActiveFilters = selectedType !== null || selectedAgeRating !== null;

  return (
    <div className="bg-white p-4 rounded-xl shadow-sm mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <SlidersHorizontal className="h-5 w-5 text-brand-teal" />
          <h3 className="font-medium text-gray-900">Filtros</h3>
        </div>
        
        {hasActiveFilters && (
          <button
            onClick={resetFilters}
            className="text-sm text-gray-500 hover:text-gray-700 flex items-center gap-1"
          >
            <X className="h-4 w-4" />
            Limpar filtros
          </button>
        )}
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Filtro por tipo */}
        <div>
          <p className="text-sm text-gray-600 mb-2">Tipo</p>
          <div className="flex gap-2">
            <button
              onClick={() => setSelectedType(selectedType === 'livro' ? null : 'livro')}
              className={`flex-1 py-2 px-3 rounded-lg flex items-center justify-center gap-1 text-sm ${
                selectedType === 'livro'
                  ? 'bg-brand-teal text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              <Book className="h-4 w-4" />
              <span>Livros</span>
            </button>
            
            <button
              onClick={() => setSelectedType(selectedType === 'filme' ? null : 'filme')}
              className={`flex-1 py-2 px-3 rounded-lg flex items-center justify-center gap-1 text-sm ${
                selectedType === 'filme'
                  ? 'bg-brand-teal text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              <Film className="h-4 w-4" />
              <span>Filmes</span>
            </button>
          </div>
        </div>
        
        {/* Filtro por classificação etária */}
        <div>
          <p className="text-sm text-gray-600 mb-2">Classificação Etária</p>
          <select
            value={selectedAgeRating || ''}
            onChange={(e) => setSelectedAgeRating(e.target.value || null)}
            className="w-full px-3 py-2 bg-gray-100 border-none rounded-lg text-gray-700 text-sm focus:ring-2 focus:ring-brand-teal"
          >
            <option value="">Todas as idades</option>
            {ageRatingOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
        
        {/* Ordenação */}
        <div>
          <p className="text-sm text-gray-600 mb-2">Ordenar por</p>
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value as 'recent' | 'title')}
            className="w-full px-3 py-2 bg-gray-100 border-none rounded-lg text-gray-700 text-sm focus:ring-2 focus:ring-brand-teal"
          >
            <option value="recent">Mais recentes</option>
            <option value="title">Título (A-Z)</option>
          </select>
        </div>
      </div>
    </div>
  );
}